import React from 'react'
import { Collapse } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { userAuthenticatedState } from 'src/features'
import styles from './SettingsPageContent.module.scss'
import { getSettingsSections } from './settings.sections'
import CustomPanelItem from './CustomPanelItem/CustomPanelItem'
import CustomPanelHeader from './CustomPanelHeader/CustomPanelHeader'
import type { ExpandIconPosition } from 'antd/lib/collapse/Collapse'

const SettingsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const user = useAppSelector(userAuthenticatedState)
  const sections = getSettingsSections(t, user)

  const collapseProps = {
    bordered: true,
    defaultActiveKey: ['DETAILS'],
    expandIconPosition: 'right' as ExpandIconPosition,
  }

  return (
    <Collapse {...collapseProps}>
      {sections.map((section) => (
        <Collapse.Panel
          key={section.key}
          className={styles.optionsSettings}
          header={<CustomPanelHeader {...section.headerProps} />}
        >
          {section.panels.map((panel, idx) => {
            if (!panel.isVisible) return
            return <CustomPanelItem key={idx} {...panel.props} />
          })}
        </Collapse.Panel>
      ))}
    </Collapse>
  )
}

export default SettingsPageContent
